/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const menuItems = navigation.querySelectorAll('.nav li, .gh-dropdown li');

    const closeMenu = function () {
        navigation.classList.remove('is-open');
        document.documentElement.style.overflowY = null;
        menuItems.forEach(function (item) {
            item.classList.remove('is-visible');
            item.style.transitionDelay = '';
        });
    };

    burger.addEventListener('click', function () {
        if (navigation.classList.contains('is-open')) {
            closeMenu();
            return;
        }

        navigation.classList.add('is-open');
        document.documentElement.style.overflowY = 'hidden';

        menuItems.forEach(function (item, index) {
            item.style.transitionDelay = (0.05 * (index + 1)) + 's';
            item.classList.add('is-visible');
        });
    });

    document.addEventListener('click', function (e) {
        if (!navigation.classList.contains('is-open')) return;
        if (navigation.contains(e.target)) return;
        closeMenu();
    });

    document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') closeMenu();
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth >= 992) {
            closeMenu();
        }
    });
})();

/* Subtle parallax drift for hero elements */
(function () {
    const elements = document.querySelectorAll('[data-parallax]');
    if (!elements.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    const update = function () {
        const offset = window.scrollY;

        elements.forEach(function (element) {
            const speed = parseFloat(element.dataset.parallax) || 0.05;
            element.style.transform = 'translate3d(0, ' + (offset * speed) + 'px, 0)';
        });

        ticking = false;
    };

    window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
    }, {passive: true});
})();

/* Add lightbox to gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();